module.exports = __webpack_public_path__ + "img/391e4fd.png";